export default __webpack_public_path__ + "static/media/DownloadColor.5dddb357.svg";